import { Modal, Button, notification } from 'antd'
import axios from 'axios'
import React, { useState } from 'react'
import { CheckCircleTwoTone, WarningTwoTone } from '@ant-design/icons';
import baseUrl, { betaBaseUrl } from '../../config';
import { useTranslation } from 'react-i18next';

const DeleteConstraint = ({
    modalOpen1,
    setModalOpen1,
    modifiedData,
    refresh,
    setRefresh,
    isBeta
}) => {
    const { t } = useTranslation();
    const [allData, setAllData] = useState({
        code: "",
    })

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement, value, icon) => {
        api.info({
            message: t('constraint.systemInfo'),
            description: `${value}`,
            placement,
            icon: icon || <CheckCircleTwoTone twoToneColor="#52c41a" />,
        });
    };

    const handleChange = (e) => {
        setAllData({ [e.target.name]: e.target.value });
    }


    const handleSubmit = (e) => {
        e.preventDefault()
        // API endpoint'ini ortama göre ayarla
        const apiEndpoint = isBeta ? `${betaBaseUrl}/delPanel` : `${baseUrl}/delPanel`;
        
        axios.post(apiEndpoint, ({ code: allData.code }))
            .then(res => {
                if (res.status === 200) {
                    setModalOpen1(false)
                    openNotification('top', 'Gönderildi')
                    setAllData({
                        code: ""
                    })
                    setRefresh(!refresh)
                }
                if (res.status === 201) {
                    openNotification('top', res.data, <WarningTwoTone twoToneColor="red" />)
                }
            });
    }

    return (
        <>
            {contextHolder}
            <Modal
                title={`${t('constraint.deletePanel')} ${isBeta ? '(Beta)' : ''}`}
                centered
                open={modalOpen1}
                onCancel={() => {
                    setAllData({
                        code: "",
                    })
                    setModalOpen1(false)
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <form onSubmit={handleSubmit}>
                    <div className='w-full flex flex-col gap-10 justify-center mt-8'>
                        <div className='flex'>
                            <label className='flex w-32 mt-1'>{t('constraint.panelCode')} : </label>
                            <input required type='text' onChange={handleChange} name="code" placeholder={t('constraint.enterPanelCode')} value={allData.code} className='border border-solid border-borderColor rounded-lg  h-33px w-full' />
                        </div>
                        <div className='w-full flex flex-col gap-3 justify-center mt-8'>
                            <Button type='submit' htmlType='submit' className='flex justify-center items-center bg-smartoptLogoColor text-white font-bold text-base '>{t('constraint.submit')}</Button>
                        </div>
                    </div>
                </form>
            </Modal>
        </>
    )
}

export default DeleteConstraint